import Container, { Service } from "typedi";
import IHttpClientGetParameters from "../contracts/http-client/http-client-get-parameters.interface";
import IHttpClientPatchParameters from "../contracts/http-client/http-client-patch-parameters.interface";
import IHttpClientPostParameters from "../contracts/http-client/http-client-post-parameters.interface";
import HttpClient from "./http-client.service";

@Service()
export default class EventService {

    public async mcProStart (event_identifier: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/mcpro-start`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).post(httpParams,event_identifier)
        return response
    }

    public async mcProReturn (event_identifier: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/mcpro-return`,
            requireToken: true,
            payload: { url: window.location.href }
        }
        const response: any = await Container.get(HttpClient).post(httpParams,event_identifier)
        return response
    }

    public async mcTradeStart (event_identifier: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/mctrade-start`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).post(httpParams,event_identifier)
        return response
    }

    public async mcTradeReturn (event_identifier: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/mctrade-return`,
            requireToken: true,
            payload: { url: window.location.href }
        }
        const response: any = await Container.get(HttpClient).post(httpParams,event_identifier)
        return response
    }

    public async nimbleStart (event_identifier: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/nimble-start`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).post(httpParams,event_identifier)
        return response
    }

    public async nimbleReturn () {
        const httpParams: IHttpClientPostParameters = {
            url: `/nimble-return`,
            requireToken: true,
            payload: { url: window.location.href }
        }
        const response: any = await Container.get(HttpClient).post(httpParams)
        return response
    }

    public async salesforceStart (event_identifier: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/salesforce-start`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async salesforceReturn () {
        const httpParams: IHttpClientPostParameters = {
            url: `/salesforce-return`,
            requireToken: true,
            payload: { url: window.location.href }
        }
        const response: any = await Container.get(HttpClient).post(httpParams)
        return response
    }

    public async searchSalesforceMembers (event_identifier: string, params: { first_name?: string; last_name?: string; email?: string; company?: string }) {
        const query = Object.entries(params)
            .filter(([, value]) => !!value)
            .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`)
            .join('&')
        const httpParams: IHttpClientGetParameters = {
            url: `/event/${event_identifier}/salesforce-member-search${query ? `?${query}` : ''}`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).get(httpParams, event_identifier)
        return response
    }

    public async registerSalesforceParticipant (event_identifier: string, contact_id: string, registration_link?: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/salesforce-member-register`,
            requireToken: true,
            payload: { contact_id, registration_link }
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async searchNimbleMembers (event_identifier: string, params: { first_name?: string; last_name?: string; email?: string; company?: string }) {
        const query = Object.entries(params)
            .filter(([, value]) => !!value)
            .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`)
            .join('&')
        const httpParams: IHttpClientGetParameters = {
            url: `/event/${event_identifier}/nimble-member-search${query ? `?${query}` : ''}`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).get(httpParams, event_identifier)
        return response
    }

    public async registerNimbleParticipant (event_identifier: string, contact_id: string, registration_link?: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/nimble-member-register`,
            requireToken: true,
            payload: { contact_id, registration_link }
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async fontevaStart (event_identifier: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/fonteva-start`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async fontevaReturn () {
        const httpParams: IHttpClientPostParameters = {
            url: `/fonteva-return`,
            requireToken: true,
            payload: { url: window.location.href }
        }
        const response: any = await Container.get(HttpClient).post(httpParams)
        return response
    }

    public async searchFontevaMembers (event_identifier: string, params: { first_name?: string; last_name?: string; email?: string; company?: string }) {
        const query = Object.entries(params)
            .filter(([, value]) => !!value)
            .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`)
            .join('&')
        const httpParams: IHttpClientGetParameters = {
            url: `/event/${event_identifier}/fonteva-member-search${query ? `?${query}` : ''}`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).get(httpParams, event_identifier)
        return response
    }

    public async registerFontevaParticipant (event_identifier: string, contact_id: string, registration_link?: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/fonteva-member-register`,
            requireToken: true,
            payload: { contact_id, registration_link }
        }
        const response: any = await Container.get(HttpClient).post(httpParams, event_identifier)
        return response
    }

    public async getEvent (event_identifier: string) {
        const httpParams: IHttpClientGetParameters = {
            url: `/event/${event_identifier}`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).get(httpParams,event_identifier)
        return response
    }

    public async sendAnalytics (event_identifier: string, data: any) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/analytics`,
            requireToken: true,
            payload: data
        }
        const response: any = await Container.get(HttpClient).post(httpParams,event_identifier)
        return response
    }

    public async sendReceipt(event_identifier: string, participant_token: string) {
        const httpParams: IHttpClientPostParameters = {
            url: `/event/${event_identifier}/participant/me/email-receipt?auth_token=${participant_token}`,
            requireToken: true,
            payload: {}
        }
        await Container.get(HttpClient).post(httpParams, event_identifier)
    }

    public async receipt(event_identifier: any, pagenum: any) {
        const httpParams: IHttpClientPatchParameters = {
            url: `/event/${event_identifier}/participant/me/registration-form/${pagenum}`,
            requireToken: true
        }
        const response: any = await Container.get(HttpClient).patch(httpParams,event_identifier)
        return response
    }
}
